//#region IMPORTS
import { useAppDispatch, useAppSelector } from "../../store/configureStore";
import { setOrdersWithSuborders } from "../../features/orders/ordersSlice";
import { useTranslation } from "react-i18next";
import ToggleButton from "../genericButtons/toggleButton/ToggleButton";
//#endregion

export default function OrdersTableControlePanelViewActions() {
  //#region SETUP
  // Translations
  const { t } = useTranslation();

  // Redux
  const dispatch = useAppDispatch();
  const { showOrdersWithSuborders, orders_loaded } = useAppSelector(
    (state) => state.orders
  );
  //#endregion

  //#region RENDER
  return (
    // No right margin: the toggle's right edge lines up with the table and the
    // pagination bar (it used to sit 1.5rem inside, with the switch's own side
    // margins on top).
    <div className="flex gap-4 items-center">
      <ToggleButton
        switchDisabled={!orders_loaded}
        startValue={showOrdersWithSuborders}
        label={
          showOrdersWithSuborders
            ? t("rituals.hideAllParcelInfo")
            : t("rituals.showAllParcelInfo")
        }
        toggleHandler={() => {
          dispatch(setOrdersWithSuborders(!showOrdersWithSuborders));
        }}
      />
    </div>
  );
  //#endregion
}
